import type { IArrayField, LoopFormat, ConditionType } from './utils';

export interface ISystemVariable {
  name: string;
  description: string;
  value?: any;
}

export interface IVariableConfig {
  enabled: boolean;
  availableVariables?: any[];
  onVariableInsert?: (variablePath: string) => void;
  allowCustomVariables?: boolean;
}

export interface ITemplateButtonsConfig {
  schema?: Record<string, unknown>;
  arrayFields?: IArrayField[];
  systemVariables?: ISystemVariable[];
  onVariableSelect?: (variablePath: string) => void;
  onLoopSelect?: (
    arrayPath: string,
    format: LoopFormat,
    isRelative?: boolean,
    parentItemName?: string
  ) => void;
  onConditionSelect?: (
    variablePath: string,
    conditionType: ConditionType
  ) => void;
}

export interface IVariableFormatting {
  bold: boolean;
  italic: boolean;
  underline: boolean;
  strikethrough: boolean;
  superscript: boolean;
  subscript: boolean;
  alignment: TextAlignment;
  textBlock: TextBlock;
  fontFamily: string;
  fontSize: string;
}

export enum TextAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum FontStyle {
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
  Strikethrough = 'strikethrough',
  Superscript = 'superscript',
  Subscript = 'subscript',
}

export enum TextBlock {
  Paragraph = 'p',
  Heading1 = 'h1',
  Heading2 = 'h2',
  Heading3 = 'h3',
  Heading4 = 'h4',
  Heading5 = 'h5',
  Heading6 = 'h6',
}

export interface ILoopInsertValues {
  arrayPath: string;
  format: LoopFormat;
  isRelative: boolean;
  parentItemName?: string;
}
